import { Component, Input, OnInit } from '@angular/core';
const DOT_LENGTH = 3;
@Component({
  selector: 'app-smart-table-long-string-ellipsis',
  templateUrl: './smart-table-long-string-ellipsis.component.html',
  styleUrls: ['./smart-table-long-string-ellipsis.component.scss'],
})
export class SmartTableLongStringEllipsisComponent implements OnInit {
  @Input() value: any;
  rowData: string;
  truncateLength: number = 25;
  eachSubstringLength: number;

  constructor() {}

  ngOnInit(): void {
    if (this.value) {
      try {
        const parsedValue = JSON.parse(this.value);
        this.rowData = parsedValue?.value;
        this.truncateLength = parsedValue?.truncateLength;
        this.eachSubstringLength = this.getTruncatedStringLength(
          this.truncateLength,
          DOT_LENGTH,
        );
      } catch (error) {}
    }
  }

  get typeOfRowData() {
    return typeof this.rowData;
  }

  getTruncatedStringLength(
    truncateLength: number,
    dotLength: number = DOT_LENGTH,
  ) {
    const totalCharsToDisplay = truncateLength - dotLength;
    const eachSubstringLength = Math.floor(totalCharsToDisplay / 2);
    return eachSubstringLength;
  }
}
